export const bodyParts = [
  'Neck and shoulders',
  'Upper back',
  'Lower back',
  'Arms and hands',
  'Legs and feet',
  'Full body',
  'Face and scalp',
  'Chest and abdomen'
];